module.exports = __webpack_public_path__ + "img/ic-delete.f9c97823.svg";